import { type PantryConfig, PantryConfigProvider } from '@side/pantry';
import { usePathname } from 'next/navigation';
import { type ReactNode, useMemo } from 'react';
import { useTrackEvent } from '$analytics/useTrackAnalytics';
import { useAppFlags } from '$launch-darkly/app-flags';
import { updateSessionUserFlagValue } from '$launch-darkly/updateSessionUserFlagValue';

export function PantryProvider({ children }: { children: ReactNode }) {
  const featureFlags = useAppFlags();
  const nextPathname = usePathname();
  const trackEvent = useTrackEvent();

  const config: PantryConfig = useMemo(
    () => ({
      featureFlags,
      nextPathname,
      trackEvent,
      updateSessionUserFlagValue,
    }),
    [featureFlags, nextPathname, trackEvent],
  );

  return (
    <PantryConfigProvider config={config}>{children}</PantryConfigProvider>
  );
}
